// Periodo di prova (trial) — costanti e helper condivisi tra i backend auth.
//
// La scadenza è salvata su `users/{uid}.trialEndsAt` come Firestore Timestamp
// (in locale come numero di millisecondi), così l'amministratore può modificarla
// direttamente dalla console Firebase con il selettore data. Gli account SENZA
// `trialEndsAt` non scadono mai (es. account creati prima di questa feature).

// Nome del piano in periodo di prova.
export const TRIAL_PLAN = 'Demo';
export const TRIAL_DAYS = 7;
export const TRIAL_MS = TRIAL_DAYS * 24 * 60 * 60 * 1000;
// Sotto questa soglia (giorni alla scadenza) lo stato passa a "In scadenza".
export const TRIAL_WARN_DAYS = 7;

// Normalizza trialEndsAt (Firestore Timestamp | numero ms | null) in millisecondi.
export const trialEndsMillis = (raw) => {
  if (raw == null) return null;
  if (typeof raw === 'number') return raw;
  if (typeof raw.toMillis === 'function') return raw.toMillis();      // Firestore Timestamp
  if (typeof raw.seconds === 'number') return raw.seconds * 1000;     // Timestamp serializzato
  return null;
};

// true se la prova è scaduta. `endsMillis` null → mai scaduta (nessun trial).
export const isTrialExpired = (endsMillis) => endsMillis != null && Date.now() > endsMillis;

// Stato dell'abbonamento in base alla scadenza:
//   null          → nessun trial impostato (account senza scadenza)
//   'scaduto'     → oltre la data di scadenza
//   'in_scadenza' → mancano meno di TRIAL_WARN_DAYS giorni
//   'attivo'      → altrimenti
export const trialStatus = (endsMillis) => {
  if (endsMillis == null) return null;
  const now = Date.now();
  if (now > endsMillis) return 'scaduto';
  const daysLeft = (endsMillis - now) / 86400000;
  return daysLeft < TRIAL_WARN_DAYS ? 'in_scadenza' : 'attivo';
};
